<template lang="pug">
  .container
    .row
      .column.small-12.large-2
        selectize-vehicle(@optionSelected="setVehicle" @optionRemoved="unsetVehicle")
      .column.small-12.large-10(v-if="showCloneForm")
        textarea(v-model = 'dataCsv' rows=10 placeholder='Paste your csv')
    .row(v-if="firstRows && showCloneForm")
      .column.small-4.large2
        label CSV separator
        select(v-model='sep')
          option(:value='undefined' selected) select your csv delimiter
          option(value="\t") tab(\t)
          option(value=";") ;
          option(value=",") ,
      .column.small-4.large2
        label Remove first row header
        input(type="checkbox" ref="checkbox" v-model="deletedCsvField")

    div(style="border:1px solid blue; padding:5px" v-if="firstRows && showCloneForm")
      .row
        .column(v-for="(row, index) in firstRows[0]")
          select( v-model="headerColumn[index]")
            option(:value='undefined' selected) select correct header
            option(value='vin') vin
            option(value='plate') plate
            option(value='hw_serial') serial
      .row(v-for="(row, index) in firstRows" style="margin-bottom:5px")
        .column(v-for="i in row")
          span {{i}}

      .row
        .column
          .button(@click="clone" :disabled="clonedisabled") clone

</template>

<script type="text/babel">
import SelectionList from "../../components/structure/SelectionList";
import Operations from "./controllers/Operations";
import SelectizeVehicle from "../../components/structure/ui/lists/selectize/SelectizeVehicle";
import KeplerBackofficeSdk from "../../lib/kepler/backoffice";

export default {
  name: "CloneVehicle",
  components: {SelectizeVehicle, Operations, SelectionList},
  data() {
    return {
      dataCsv: '',
      eol: '\n',
      // sep: '\t',
      sep: undefined,
      headerColumn: [],
      firstRow: [],
      rows: [],
      vehicle_id: null,
      showCloneForm: false,
      deletedCsvField: false,
      clonedisabled: false,
      import_type: 'clone_vehicle',
      data: '',

    }
  },

  watch: {
    dataCsv: function (newValue, oldValue) {
      this.getRows()

      var max = 0;
      if (this.rows.length > 0) {
        var row = this.rows[0];
        ['\t', ';', ','].forEach(x => {
          const l = row.split(x).length
          if (l > max) {
            max = l
            this.sep = x;
          }
        })
      }
    }

  },
  methods: {
    clone() {
      // check headerColumns
      const duplicates = this.headerColumn.filter((e, i, a) => a.indexOf(e) !== i)

      if (duplicates.length) {
        alert('Please check for duplicates header: ' + duplicates)
        return
      }
      const choosen = this.headerColumn.filter(x => x).length; //remove empty rows
      if (choosen !== 3) {
        alert('Please choose all headers mapping')
        return
      }
      const mappings = {}
      this.headerColumn.forEach((x, idx) => {
        if (!!x) {
          if (x === 'vin') {
            mappings['attributes'] = {'vin': idx}
          } else {
            mappings[x] = idx
          }
        }
      })

      const config = {
        'vehicle_id': this.vehicle_id,
        'mappings': mappings,
        'data': this.createDataString()
      }
      const body = {
        'import_type': this.import_type,
        config: config,
      }
      this.clonedisabled = true

      KeplerBackofficeSdk.clone.cloneVehicle(body, data => {
        alert(JSON.stringify(data))
        this.clonedisabled = false
      })
      console.log(config)
    },
    createDataString() {

      var arrTmp = []
      this.rows.forEach(item => {
        arrTmp.push(item.split(this.sep))
      })

      var arr = []
      arrTmp.forEach(i => {
        arr.push(i.join('\t'))
      })
      this.data = arr.join('\n')
      this.data = this.data + "\n"

      return this.data

    },
    updateTextArea(event) {
      this.dataCsv = event.target.value
    },

    setVehicle(object) {
      this.showCloneForm = true
      this.vehicle_id = object.id

    },

    unsetVehicle(object) {
      this.showCloneForm = false
      this.vehicle_id = null
    },

    getRows() {
      this.rows = this.dataCsv
        .replaceAll(' ', '')
        .split(this.eol)
        .filter(x => x); //remove empty rows
    }
  },

  computed: {
    firstRows: function () {
      this.getRows();
      if (this.rows.length <= 0) {

        return null
      }

      if (this.deletedCsvField)
        this.rows = this.rows.slice(1)
      const grid = []
      this.rows.slice(0, 3).forEach(s => {
        grid.push(s.split(this.sep))
      })
      grid.push(new Array(grid[0].length).fill('...............'))
      return grid

    }

  }
}
</script>

<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// CloneVehicle.vue?130729fa